<style>
    .categoriesTabs{
        text-align: center;
        padding: 20px;
    }

    .featured-category-image h6:hover{
        color: #ee3240;
    }

    .featured-category-name{
        padding: 20px;
    }

    figure .img-rounded{
        border-radius: 50%;
        width: 70%;
        border: 1px solid #d3d1d1;
        -webkit-transform: scale(1);
        transform: scale(1);
        -webkit-transition: .3s ease-in-out;
        transition: .3s ease-in-out;
    }

    figure .img-rounded:hover {
        -webkit-transform: scale(1.3);
        transform: scale(1.3);
        border: 1px solid #ee3240;
    }

    @media only screen and (min-width: 1282px) {
        .sectionFeatured{
            display: none;
        }
    }

    @media only screen and (min-width: 320px) and (max-width: 1281px) {
        /* for 10 inches tablet screens */
        .sectionFeatured{
            display: block;
        }
        .sectionFeatured .row{
            margin-left: 24px;
        }

        .featured-category-name{
            padding: 0;
        }
    }
</style>
<template>
    <section class="banner-wrap three-column-banner sectionFeatured">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-8 categoriesTabs" v-for="category in data.categories">
                    <a class="featured-category-image" :href="`/categories/${category.slug}/products`">
                        <figure v-if="!Array.isArray(category.logo)"><img :src="category.logo.path" alt="category logo" class="img-fluid img-rounded"></figure>
                        <figure v-else><img :src="`/themes/storefront/public/images/image-placeholder.png`" class="image-placeholder img-rounded" alt="category logo"></figure>
                        <h6 class="featured-category-name">{{ category.name }}</h6>
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: ['data'],
    };
</script>
